<div class="App">
  <input placeholder="Enter your name" [(ngModel)]="name" />

  <div class="greeting">Hello {{name}}!</div>

  <search-result [attr.name-attribute]="name"></search-result>
</div>
